// Author YuJiaBei
// Date 2020-12-02 16:57:54

class EmMenuType {
constructor({
        id = null,
        code = '',
        name = '',
        description = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.description = description;
}
}

function newEntity() {
return new EmMenuType();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'code',
        label: 'label.em.admin.emMenuType.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.admin.emMenuType.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'description',
        label: 'label.em.admin.emMenuType.grid.description',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    codeFilter : "",
    nameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'codeFilter',
        label: 'label.em.admin.emMenuType.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.admin.emMenuType.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'code',
        label: 'label.em.admin.emMenuType.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'name',
        label: 'label.em.admin.emMenuType.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'description',
        label: 'label.em.admin.emMenuType.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {EmMenuType, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
